const SHORT_LABEL_LENGTH = 3;

export const capitalizeFirstLetter = (text) => {
  const isUsableText = typeof text === "string" && text.length > 0;
  if (isUsableText) {
    const firstLetter = text.charAt(0).toUpperCase();
    const remainingLetters = text.slice(1);
    const capitalizedText = firstLetter + remainingLetters;
    return capitalizedText;
  }
  return "";
};

export const formatMenuLabel = (label) => {
  const isShortLabel = label.length < SHORT_LABEL_LENGTH;
  if (isShortLabel) {
    const uppercasedLabel = label.toUpperCase();
    return uppercasedLabel;
  }
  const capitalizedLabel = capitalizeFirstLetter(label);
  return capitalizedLabel;
};
